export const swiftuser = {
  namespaced: true,
  state: {
    organizationId: null,
    digiBoardId: null,
    user: {},
    mobile: '' // This is for new users to remember the number once they entered.
  },
  getters: {
    getOrganizationId (state) {
      if (state.organizationId !== null) {
        return state.organizationId
      }

      return localStorage.getItem('organizationId')
    },
    getDigiBoardId (state) {
      if (state.digiBoardId !== null) {
        return state.digiBoardId
      }

      return localStorage.getItem('digiBoardId')
    },
    getUser (state) {
      return state.user
    },
    getMobile (state) {
      return state.mobile
    }
  },
  actions: {
    onHomePageHit (context, payload) {
      context.commit('addUserDetails', payload)
    },
    onAddUser (context, user) {
      context.commit('addUser', user)
    },
    onNewUserMobile (context, mobile) {
      context.commit('addNewUserMobile', mobile)
    },
    onCancel (context) {
      context.commit('doCancelActions')
    }
  },
  mutations: {
    addUserDetails (state, payload) {
      state.organizationId = payload.organization_id
      state.digiBoardId = payload.digi_board_id
      localStorage.setItem('organizationId', payload.organization_id)
      localStorage.setItem('digiBoardId', payload.digi_board_id)
    },
    addUser (state, user) {
      state.user = user
    },
    addNewUserMobile (state, mobile) {
      state.mobile = mobile
    },
    doCancelActions (state) {
      state.mobile = null
      state.user = {}
    }
  }
}
